import * as Yup from 'yup'

export const validationSchema = Yup.object({
    tenantId: Yup.string().required('Tenant field is required'),
    userObjectId: Yup.string().required('User field is required'),
})